import { useEffect, useRef } from 'react';

import {
  CourseType,
  type OffsetPageResponseMyChallengeVoucherDto,
  type OffsetPageResponseMyVoucherDto,
} from '../../../../../../resources/@types/courseSchema';
import { eventNames } from '../../../../../utils/GTM/eventNames';
import { useTrackMixpanelEvent } from '../../../../../utils/GTM/useTrackMixpanelEvent';

type Params = {
  myVoucher?: OffsetPageResponseMyVoucherDto | OffsetPageResponseMyChallengeVoucherDto;
  courseType: CourseType;
};

export default function useViewMyCoursesPageEvent({ myVoucher, courseType }: Params) {
  const { trackMixpanelEvent, isReady } = useTrackMixpanelEvent();

  const isAlreadyViewed = useRef(false);
  const vouchers = myVoucher?.items || [];
  const voucherTotalCount = myVoucher?.totalCount || 0;

  useEffect(() => {
    if (!isReady || !myVoucher || isAlreadyViewed.current) {
      return;
    }

    isAlreadyViewed.current = true;
    trackMixpanelEvent(eventNames.VIEW_MY_COURSES, {
      course_identification: vouchers.map((voucher) => voucher.course.id),
      course_title: vouchers.map((voucher) => voucher.course.title),
      course_type:
        courseType === CourseType.ON ? 'on' : courseType === CourseType.OFF ? 'off' : 'challenge',
      seq0_instructor_id: vouchers.map((voucher) => voucher.course.instructorId),
      seq0_instructor_name: vouchers.map((voucher) => voucher.course.instructorName),
      course_limit_at: vouchers.map((voucher) => voucher.limitedAt || '무제한'),
      progress: vouchers.map((voucher) => Number(voucher.progress)),
      course_count: voucherTotalCount,
    });
  }, [isReady, myVoucher, courseType, trackMixpanelEvent, vouchers, voucherTotalCount]);
}
